import React from "react";

const CrossIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_853_12404)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3033 4.69661C15.6287 5.02205 15.6287 5.54968 15.3033 5.87512L11.1785 9.99991L15.3033 14.1247C15.6287 14.4501 15.6287 14.9778 15.3033 15.3032C14.9779 15.6286 14.4502 15.6286 14.1248 15.3032L10 11.1784L5.87521 15.3032C5.54977 15.6286 5.02214 15.6286 4.6967 15.3032C4.37126 14.9778 4.37126 14.4501 4.6967 14.1247L8.82149 9.99991L4.6967 5.87512C4.37126 5.54968 4.37126 5.02205 4.6967 4.69661C5.02214 4.37117 5.54977 4.37117 5.87521 4.69661L10 8.8214L14.1248 4.69661C14.4502 4.37117 14.9779 4.37117 15.3033 4.69661Z"
          fill="#646F87"
        />
      </g>
      <defs>
        <clipPath id="clip0_853_12404">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CrossIcon;
